import { render } from "./UserChip.vue?vue&type=template&id=5c467dc0"
import script from "./UserChip.vue?vue&type=script&lang=js"
export * from "./UserChip.vue?vue&type=script&lang=js"
script.render = render

export default script